import React from 'react';
import { PricingStrategy, RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { FreeDomainBadge, PremiumDomainBadge, SearchRecommendationLayout } from '@wix/domains-search-suite';
export const createOptimizedLabelContainer = () => _ref => {
  let premium = _ref.premium,
    domain = _ref.domain,
    label = _ref.label;
  return premium ? /*#__PURE__*/React.createElement(SearchRecommendationLayout.LabelContainer, {
    premium: true,
    visible: true,
    domain: domain,
    label: label
  }, /*#__PURE__*/React.createElement(PremiumDomainBadge, null)) : null;
};
export const createLeanLabelContainer = _ref2 => {
  let listItems = _ref2.listItems,
    heroRecommendation = _ref2.heroRecommendation,
    hideFreeWithSitePlanBadge = _ref2.hideFreeWithSitePlanBadge,
    recommendations = _ref2.recommendations;
  return _ref3 => {
    var _listItems$, _recommendations$find;
    let premium = _ref3.premium,
      domain = _ref3.domain,
      label = _ref3.label,
      children = _ref3.children;
    const isMatchQualityLabel = label === RecommendationLabel.BEST_MATCH || label === RecommendationLabel.GREAT_ALTERNATIVE || label === RecommendationLabel.EXACT_MATCH;
    const isFirstListItem = ((_listItems$ = listItems[0]) == null ? void 0 : _listItems$.domain) === domain;
    const showLabel = isMatchQualityLabel && isFirstListItem && !heroRecommendation;
    const isFreeFirstYear = !hideFreeWithSitePlanBadge && ((_recommendations$find = recommendations.find(r => r.domain === domain)) == null || (_recommendations$find = _recommendations$find.price) == null ? void 0 : _recommendations$find.pricingStrategy) === PricingStrategy.FREE_FIRST_YEAR;
    if (!premium && !showLabel && !isFreeFirstYear) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SearchRecommendationLayout.LabelContainer, {
      premium: premium,
      visible: true,
      domain: domain,
      label: label
    }, premium ? /*#__PURE__*/React.createElement(PremiumDomainBadge, null) : showLabel ? children : /*#__PURE__*/React.createElement(FreeDomainBadge, null));
  };
};
//# sourceMappingURL=suggestionLabelContainers.js.map